jQuery(function ($) {
  var MOBILE_BREAKPOINT = 768;

  function getPerView() {
    var w = window.innerWidth;
    if (w <= 749) return 2;
    if (w <= 990) return 3;
    if (w <= 1200) return 4;
    return 5;
  }

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  $('.featured_products_2026').each(function () {
    var $section  = $(this);
    var $viewport = $section.find('.featured_products_slideshow').first();
    var $prev     = $section.find('.featured_products_arrows .left_arrow');
    var $next     = $section.find('.featured_products_arrows .right_arrow');

    if (!$viewport.length) return;

    // Build track if it doesn't exist
    var $track = $viewport.find('.featured_products_track');
    if (!$track.length) {
      var $slides = $viewport.children('.featured_prod_slide');
      $track = $('<div class="featured_products_track"></div>');
      $track.append($slides);
      $viewport.append($track);
    }

    var $slides = $track.children('.featured_prod_slide');
    if (!$slides.length) return;

    var index = 0;
    var ns = '.fp2026_' + Math.floor(Math.random() * 1000000);

    function clampIndex(i, perView) {
      var max = Math.max(0, $slides.length - perView);
      return Math.max(0, Math.min(i, max));
    }

    function applySizing() {
      if (isMobile()) {
        $track.css({ transform: '', transition: '' });
        $slides.css({ width: '', marginRight: '' });
        updateFakeScrollbar();
        return;
      }

      var perView = getPerView();
      var viewportW = $viewport.width();
      var gap = 16;

      var totalGap = gap * (perView - 1);
      var slideW = (viewportW - totalGap) / perView;

      $slides.css({ width: slideW + 'px', marginRight: '' });

      index = clampIndex(index, perView);
      move(true);
    }

    function move(immediate) {
      if (isMobile()) return;

      var gap = 16;
      var slideW = $slides.outerWidth();
      var x = -(index * (slideW + gap));

      if (immediate) $track.css('transition', 'none');
      $track.css('transform', 'translateX(' + x + 'px)');
      if (immediate) {
        $track[0].offsetHeight;
        $track.css('transition', 'transform 300ms ease');
      }
      updateArrows();
    }

    function step(dir) {
      if (isMobile()) return;
      var perView = getPerView();
      index = clampIndex(index + dir, perView);
      move(false);
    }

    function updateArrows() {
      if (isMobile()) {
        $prev.removeClass('disabled');
        $next.removeClass('disabled');
        return;
      }

      var perView = getPerView();
      var maxIndex = Math.max(0, $slides.length - perView);

      if (index <= 0) {
        $prev.addClass('disabled');
      } else {
        $prev.removeClass('disabled');
      }

      if (index >= maxIndex) {
        $next.addClass('disabled');
      } else {
        $next.removeClass('disabled');
      }
    }

    $prev.off('click' + ns).on('click' + ns, function () { step(-1); });
    $next.off('click' + ns).on('click' + ns, function () { step(1); });

    // Swipe/drag support for desktop/tablet only
    var dragStartX = 0;
    var dragCurrentX = 0;
    var hasDragged = false;

    function getClientX(e) {
      var te = e.originalEvent;
      if (te.touches && te.touches.length) return te.touches[0].clientX;
      if (te.changedTouches && te.changedTouches.length) return te.changedTouches[0].clientX;
      return te.clientX;
    }

    function onDragStart(e) {
      if (isMobile()) return;
      dragStartX = getClientX(e);
      dragCurrentX = dragStartX;
      hasDragged = false;

      if (e.type === 'mousedown') {
        $(document).on('mousemove' + ns, onDragMove).one('mouseup' + ns, function (ev) {
          onDragEnd(ev);
          $(document).off('mousemove' + ns);
        });
      }
    }

    function onDragMove(e) {
      if (isMobile()) return;
      dragCurrentX = getClientX(e);
      if (Math.abs(dragCurrentX - dragStartX) > 10) hasDragged = true;
    }

    function onDragEnd() {
      if (isMobile()) return;
      var delta = dragStartX - dragCurrentX;
      var threshold = 50;

      if (hasDragged && delta > threshold) step(1);
      else if (hasDragged && delta < -threshold) step(-1);
    }

    function preventClickIfDragged(e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    $viewport
      .off('touchstart' + ns + ' mousedown' + ns)
      .on('touchstart' + ns + ' mousedown' + ns, onDragStart)
      .off('touchmove' + ns)
      .on('touchmove' + ns, onDragMove)
      .off('touchend' + ns + ' mouseleave' + ns)
      .on('touchend' + ns + ' mouseleave' + ns, onDragEnd);

    $viewport.find('a').off('click' + ns).on('click' + ns, preventClickIfDragged);

    // ----------------------------
    // Fake scrollbar (mobile only)
    // ----------------------------
    var $bar = $section.find('.featured_products_fake_scrollbar');
    var $thumb = $section.find('.featured_products_fake_thumb');

    function updateFakeScrollbar() {
      if (!isMobile()) return;
      if (!$bar.length || !$thumb.length) return;

      var el = $viewport[0];
      var scrollWidth = el.scrollWidth;
      var visibleWidth = el.clientWidth;

      if (scrollWidth <= visibleWidth) {
        $bar.hide();
        return;
      }

      $bar.show();

      var ratio = visibleWidth / scrollWidth;
      var thumbWidth = $bar.width() * ratio;

      $thumb.css('width', thumbWidth + 'px');

      var maxScroll = scrollWidth - visibleWidth;
      var maxMove = $bar.width() - thumbWidth;

      var move = maxScroll ? (el.scrollLeft / maxScroll) * maxMove : 0;

      $thumb.css('left', move + 'px');
    }

    $viewport.off('scroll' + ns).on('scroll' + ns, updateFakeScrollbar);

    $(window).off('resize' + ns).on('resize' + ns, function () {
      applySizing();
      setTimeout(updateFakeScrollbar, 50);
    });

    applySizing();
    setTimeout(updateFakeScrollbar, 50);
    updateArrows();

    // ----------------------------
    // Variant swatch sliders (per slide)
    // ----------------------------
    function getSwatchesVisible($wrapper) {
      var swatchSize = window.innerWidth < MOBILE_BREAKPOINT ? 24 : 28;
      var gap = 5;
      var slotW = swatchSize + gap;
      var arrowReserve = 2 * 32; // space reserved for left + right arrow buttons
      var wrapW = $wrapper.width();
      if (!wrapW) return window.innerWidth < MOBILE_BREAKPOINT ? 4 : 6;
      return Math.max(1, Math.floor((wrapW - arrowReserve) / slotW));
    }

    $slides.each(function () {
      var $slide = $(this);
      var $wrapper = $slide.find('.featured_swatches_wrapper');
      var $viewport = $wrapper.find('.featured_swatches_viewport');
      var $swatches = $wrapper.find('.featured_swatches');
      var $imgs = $swatches.find('img');
      var $left = $wrapper.find('.featured_swatches_arrow_left');
      var $right = $wrapper.find('.featured_swatches_arrow_right');

      var swatchPage = 0;
      var pageStep = 0;

      function initOrUpdate() {
        var swatchesVisible = getSwatchesVisible($wrapper);
        if ($imgs.length <= swatchesVisible) {
          $wrapper.removeClass('is_slider');
          $viewport.css('width', '');
          $swatches.css('transform', '');
          return;
        }
        $wrapper.addClass('is_slider');

        var maxSwatchPage = Math.ceil($imgs.length / swatchesVisible) - 1;
        swatchPage = Math.min(swatchPage, maxSwatchPage);

        function measureAndApply() {
          var slotWidth;
          if ($imgs.length >= 2) {
            var r0 = $imgs[0].getBoundingClientRect();
            var r1 = $imgs[1].getBoundingClientRect();
            slotWidth = r1.left - r0.left;
          } else {
            var itemWidth = $imgs.first().outerWidth();
            var gap = parseFloat(window.getComputedStyle($swatches[0]).gap) || 5;
            slotWidth = (itemWidth <= 0 ? 30 : itemWidth) + gap;
          }
          pageStep = swatchesVisible * slotWidth;
          $viewport.css('width', pageStep + 'px');
          moveSwatches(true);
        }

        function moveSwatches(immediate) {
          var x = -(swatchPage * pageStep);
          if (immediate) $swatches.css('transition', 'none');
          $swatches.css('transform', 'translateX(' + x + 'px)');
          if (immediate) {
            $swatches[0].offsetHeight;
            $swatches.css('transition', 'transform 300ms ease');
          }
          $left.toggleClass('disabled', swatchPage <= 0);
          $right.toggleClass('disabled', swatchPage >= maxSwatchPage);
        }

        measureAndApply();
        if (pageStep <= 0) setTimeout(measureAndApply, 50);

        function stepLeft() {
          if (swatchPage <= 0) return;
          swatchPage--;
          moveSwatches(false);
        }
        function stepRight() {
          if (swatchPage >= maxSwatchPage) return;
          swatchPage++;
          moveSwatches(false);
        }

        function blockPropagation(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        $left.off('click.vs touchend.vs mousedown.vs touchstart.vs');
        $right.off('click.vs touchend.vs mousedown.vs touchstart.vs');

        $left.on('mousedown.vs touchstart.vs', blockPropagation);
        $right.on('mousedown.vs touchstart.vs', blockPropagation);
        $left.on('click.vs touchend.vs', function (e) {
          if (e.type === 'touchend') blockPropagation(e);
          stepLeft();
        });
        $right.on('click.vs touchend.vs', function (e) {
          if (e.type === 'touchend') blockPropagation(e);
          stepRight();
        });
      }

      initOrUpdate();
      $(window).on('resize' + ns, initOrUpdate);
    });
  });
});
